<template>
    <q-modal v-model="show_test_preview_modal" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" no-backdrop-dismiss no-esc-dismiss>
        <q-modal-layout>
            <q-toolbar slot="header">
                <q-btn flat round dense @click="show_test_preview_modal = false" icon="fas fa-times" />
                <q-toolbar-title>
                    {{ $t('preview') }}
                </q-toolbar-title>
            </q-toolbar>

            <div class="layout-padding">
                <div class="row gutter-sm q-mb-md">
                    <div class="col-xs-10 col-sm-10">
                        <p class="caption text-weight-bold">{{ title ? title : '' }}</p>
                    </div>
                </div>

                <div class="row q-mb-lg">
                    <div class="col-xs-6 col-sm-3">
                        <p class="caption">{{ $t('random_questions') }}</p>
                        <q-btn-toggle v-model="randomize_questions" 
                            :toggle-color="randomize_questions ? 'positive' : 'negative'" 
                            :options="randomize_questions_options" 
                            disable
                            />
                    </div>

                    <div class="col-xs-6 col-sm-3">
                        <p class="caption">{{ $t('random_answers') }}</p>
                        <q-btn-toggle v-model="randomize_answers" 
                            :toggle-color="randomize_answers ? 'positive' : 'negative'" 
                            :options="randomize_answers_options" 
                            disable
                            />
                    </div>
                </div>

                <div class="col-12 q-mb-xl" v-for="(question, index) in preview_questions" :key="index">
                    <div class="row q-col-gutter-md">
                        <div class="col-12 q-pa-md">
                            <span>{{ `${index + 1}) ` }}</span>
                            <span v-html="question.title"></span>
                        </div>

                        <div class="col-12" v-for="answer in question.answers" :key="answer.id">
                            <q-card flat class="cursor-pointer">
                                <q-card-main>
                                    <q-item v-ripple dense>
                                        <q-item-side>
                                            <q-item-tile avatar>
                                                <q-icon class="q-pt-sm"
                                                    :name="answer.is_correct ? 'far fa-check-circle' : 'far fa-circle'"
                                                    :color="answer.is_correct ? 'green' : 'red'"
                                                    size="1.5rem" />
                                            </q-item-tile>
                                        </q-item-side>
                                        <q-item-main :label="answer.title" />
                                    </q-item>
                                </q-card-main>

                                <q-card-separator />
                            </q-card>
                        </div>
                    </div>
                </div>

                <div class="row gutter-sm justify-end q-mt-lg">
                    <div class="col-xs-12 col-sm-3" :class="this.$q.platform.is.mobile ? 'order-last' : 'order-first'">
                        <q-btn color="tertiary" class="full-width" :label="$t('close')" icon="far fa-block" @click="show_test_preview_modal = false" />
                    </div>
                </div>
            </div>
        </q-modal-layout>
    </q-modal>
</template>

<script>

export default {
    name: 'AdminTestPreviewModal',

    props: ['show_test_preview', 'title', 'questions', 'randomize_questions', 'randomize_answers'],

    data() {
        return {
            randomize_questions_options: [
                { label: this.$t('yes'), value: true },
                { label: this.$t('no'), value: false }
            ],
            randomize_answers_options: [
                { label: this.$t('yes'), value: true },
                { label: this.$t('no'), value: false }
            ],
            preview_questions: []
        }
    },

    computed: {
        show_test_preview_modal: {
            get() {
                return this.show_test_preview
            },
            set() {
                this.$emit('returnToQuestions', '')
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },
    },

    mounted () {
        this.preview_questions = this.questions

        if (this.randomize_questions) {
            this.preview_questions = this.preview_questions.map(q => {
                return {
                    ...q,
                    order: Math.floor(Math.random() * 100)
                }
            }).sort((a, b) => a.order - b.order)
        }
        if (this.randomize_answers) {
            this.preview_questions = this.preview_questions.map(q => {
                return {
                    ...q,
                    answers: q.answers.map(a => {
                        return {
                            ...a,
                            order: Math.floor(Math.random() * 100)
                        }
                    }).sort((a, b) => a.order - b.order)
                }
            })
        }
    },

    beforeDestroy () {
        this.preview_questions = []
    },
}
</script>

<style>

</style>
